"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVotesCount = exports.clearAccount = exports.isAccountEmpty = exports.getParentAccount = exports.isSubAccount = exports.isChildAccount = exports.isTokenAccount = exports.isAccount = exports.findTokenAccountByCurrency = exports.withoutToken = exports.accountWithMandatoryTokens = exports.makeEmptyTokenAccount = exports.isUpToDateAccount = exports.isAccountBalanceUnconfirmed = exports.shortAddressPreview = exports.flattenAccounts = exports.listSubAccounts = exports.findSubAccountById = exports.isAccountBalanceSignificant = exports.areAllOperationsLoaded = exports.getAccountSpendableBalance = exports.getFeesUnit = exports.getFeesCurrency = exports.getAccountUnit = exports.getAccountCurrency = exports.getAccountName = exports.getMainAccount = void 0;
const bakers_1 = require("../families/tezos/bakers");
const types_1 = require("../families/bitcoin/types");
const helpers_1 = require("@ledgerhq/coin-framework/account/helpers");
Object.defineProperty(exports, "getMainAccount", { enumerable: true, get: function () { return helpers_1.getMainAccount; } });
Object.defineProperty(exports, "getAccountName", { enumerable: true, get: function () { return helpers_1.getAccountName; } });
Object.defineProperty(exports, "getAccountCurrency", { enumerable: true, get: function () { return helpers_1.getAccountCurrency; } });
Object.defineProperty(exports, "getAccountUnit", { enumerable: true, get: function () { return helpers_1.getAccountUnit; } });
Object.defineProperty(exports, "getFeesCurrency", { enumerable: true, get: function () { return helpers_1.getFeesCurrency; } });
Object.defineProperty(exports, "getFeesUnit", { enumerable: true, get: function () { return helpers_1.getFeesUnit; } });
Object.defineProperty(exports, "getAccountSpendableBalance", { enumerable: true, get: function () { return helpers_1.getAccountSpendableBalance; } });
Object.defineProperty(exports, "areAllOperationsLoaded", { enumerable: true, get: function () { return helpers_1.areAllOperationsLoaded; } });
Object.defineProperty(exports, "isAccountBalanceSignificant", { enumerable: true, get: function () { return helpers_1.isAccountBalanceSignificant; } });
Object.defineProperty(exports, "findSubAccountById", { enumerable: true, get: function () { return helpers_1.findSubAccountById; } });
Object.defineProperty(exports, "listSubAccounts", { enumerable: true, get: function () { return helpers_1.listSubAccounts; } });
Object.defineProperty(exports, "flattenAccounts", { enumerable: true, get: function () { return helpers_1.flattenAccounts; } });
Object.defineProperty(exports, "shortAddressPreview", { enumerable: true, get: function () { return helpers_1.shortAddressPreview; } });
Object.defineProperty(exports, "isAccountBalanceUnconfirmed", { enumerable: true, get: function () { return helpers_1.isAccountBalanceUnconfirmed; } });
Object.defineProperty(exports, "isUpToDateAccount", { enumerable: true, get: function () { return helpers_1.isUpToDateAccount; } });
Object.defineProperty(exports, "makeEmptyTokenAccount", { enumerable: true, get: function () { return helpers_1.makeEmptyTokenAccount; } });
Object.defineProperty(exports, "accountWithMandatoryTokens", { enumerable: true, get: function () { return helpers_1.accountWithMandatoryTokens; } });
Object.defineProperty(exports, "withoutToken", { enumerable: true, get: function () { return helpers_1.withoutToken; } });
Object.defineProperty(exports, "findTokenAccountByCurrency", { enumerable: true, get: function () { return helpers_1.findTokenAccountByCurrency; } });
Object.defineProperty(exports, "isAccount", { enumerable: true, get: function () { return helpers_1.isAccount; } });
Object.defineProperty(exports, "isTokenAccount", { enumerable: true, get: function () { return helpers_1.isTokenAccount; } });
Object.defineProperty(exports, "isChildAccount", { enumerable: true, get: function () { return helpers_1.isChildAccount; } });
Object.defineProperty(exports, "isSubAccount", { enumerable: true, get: function () { return helpers_1.isSubAccount; } });
Object.defineProperty(exports, "getParentAccount", { enumerable: true, get: function () { return helpers_1.getParentAccount; } });
const isAccountEmpty = (a) => {
    // FIXME LIVE-5966 why do we need this? also this shouldn't be implemented here / this part must be removed back to the coin specifics
    if (a.type === "Account" && a.currency.family === "tron") {
        const tronAcc = a;
        return tronAcc.tronResources && tronAcc.tronResources.bandwidth.freeLimit.eq(0);
    }
    return (0, helpers_1.isAccountEmpty)(a);
};
exports.isAccountEmpty = isAccountEmpty;
// in future, could be a per currency thing
// clear account to a bare minimal version that can be restored via sync
// will preserve the balance to avoid user panic
function clearAccount(account) {
    // FIXME add in the coins bridge a way for a coin to define extra clean up functions to modularize this.
    return (0, helpers_1.clearAccount)(account, (account) => {
        if (account.currency.family === "tron") {
            const tronAcc = account;
            tronAcc.tronResources = Object.assign(Object.assign({}, tronAcc.tronResources), { cacheTransactionInfoById: {} });
        }
        if (account.currency.family === "bitcoin") {
            account.bitcoinResources = types_1.initialBitcoinResourcesValue;
        }
    });
}
exports.clearAccount = clearAccount;
const getVotesCount = (account, parentAccount) => {
    var _a, _b;
    const mainAccount = (0, helpers_1.getMainAccount)(account, parentAccount);
    // FIXME add this back in the coin bridge.
    switch (mainAccount.currency.family) {
        case "tezos":
            return (0, bakers_1.isAccountDelegating)(account) ? 1 : 0;
        case "tron":
            return ((_a = mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.tronResources) === null || _a === void 0 ? void 0 : _a.votes.length) || 0;
        case "axelar":
        case "onomy":
        case "quicksilver":
        case "stride":
        case "persistence":
        case "stargaze":
        case "nyx":
        case "secret_network":
        case "sei_network":
        case "desmos":
        case "umee":
        case "binance_beacon_chain":
        case "osmosis":
        case "cosmos":
            return ((_b = mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.cosmosResources) === null || _b === void 0 ? void 0 : _b.delegations.length) || 0;
        default:
            return 0;
    }
};
exports.getVotesCount = getVotesCount;
//# sourceMappingURL=helpers.js.map